import React from 'react';
export function HeroSection() {
  return <section className="bg-cream pt-[70px] pb-[60px] px-5 text-center relative overflow-hidden" data-id="element-135">
      {/* Decorative Gradients */}
      <div className="absolute -top-[100px] -right-[150px] w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(196,113,74,0.08)_0%,transparent_70%)] pointer-events-none" data-id="element-136" />
      <div className="absolute -bottom-[80px] -left-[100px] w-[400px] h-[400px] bg-[radial-gradient(circle,rgba(61,90,71,0.07)_0%,transparent_70%)] pointer-events-none" data-id="element-137" />

      <div className="inline-block bg-forest text-cream text-[0.72rem] tracking-[0.12em] uppercase py-1.5 px-4 rounded-sm mb-7 font-sans font-medium animate-fade-up" data-id="element-138">
        SISTEMA GUIADO DE ACTIVACIÓN LECTORA
      </div>

      <h1 className="font-playfair text-[clamp(2.4rem,5vw,3.8rem)] font-black text-text-dark leading-[1.1] mb-2 animate-fade-up" data-id="element-139">
        Tu hijo no odia leer.
        <br data-id="element-140" />
        <em className="italic text-terracotta block" data-id="element-141">Odia sentirse incapaz.</em>
      </h1>

      <p className="font-lora text-[clamp(1rem,2vw,1.2rem)] text-text-mid max-w-[520px] mx-auto mt-5 mb-7 leading-relaxed animate-fade-up" style={{
      animationDelay: '0.15s'
    }} data-id="element-142">
        En solo 21 días, dedicando 10 minutos por día, podés transformar esa
        frustración en confianza real.
      </p>

      <div className="bg-white border border-forest/15 border-l-4 border-l-forest rounded-lg py-[18px] px-6 max-w-[560px] mx-auto mb-7 text-left animate-fade-up" style={{
      animationDelay: '0.25s'
    }} data-id="element-143">
        <strong className="text-[0.8rem] uppercase tracking-[0.08em] text-forest block mb-1.5" data-id="element-144">
          ¿Qué es esto exactamente?
        </strong>
        <p className="text-[0.92rem] text-text-mid leading-relaxed" data-id="element-145">
          Un sistema guiado de 21 días (10 min/día) con actividades imprimibles,
          plan de acción y materiales de apoyo para que tu hijo construya la
          lectura desde la base:{' '}
          <b className="text-text-dark" data-id="element-146">sonidos → letras → palabras.</b> Sin
          presión, desde casa, sin ser maestra.
        </p>
      </div>

      <div className="inline-block bg-cream-dark border border-forest/20 rounded-full py-1.5 px-4 text-[0.83rem] text-forest mb-6 font-medium animate-fade-up" style={{
      animationDelay: '0.3s'
    }} data-id="element-147">
        👦 Para padres de niños de 4 a 9 años que se frustran o evitan la
        lectura
      </div>

      <div className="flex flex-wrap gap-2.5 justify-center mb-9 animate-fade-up" style={{
      animationDelay: '0.35s'
    }} data-id="element-148">
        {['Sistema paso a paso', 'Sin peleas', 'Sin presión', 'Sin improvisar'].map((pill, i) => <div key={i} className="bg-white border border-forest/20 rounded-full py-[7px] px-4 text-[0.8rem] text-text-mid flex items-center gap-1.5" data-id="element-149">
            <span className="text-forest font-bold" data-id="element-150">✓</span> {pill}
          </div>)}
      </div>

      <a href="#precio" className="inline-block bg-terracotta text-white font-sans text-[0.95rem] font-medium tracking-[0.06em] uppercase py-[18px] px-10 rounded text-decoration-none border-none cursor-pointer transition-all duration-200 hover:bg-terracotta-light hover:-translate-y-0.5 animate-fade-up" style={{
      animationDelay: '0.4s'
    }} data-id="element-151">
        Quiero activar la lectura en casa →
      </a>

      <button onClick={() => document.querySelector('.reframe')?.scrollIntoView({
      behavior: 'smooth'
    })} className="block mx-auto mt-3 text-[0.82rem] text-text-light underline cursor-pointer bg-transparent border-none font-sans animate-fade-up" style={{
      animationDelay: '0.45s'
    }} data-id="element-152">
        Ver cómo funciona primero
      </button>

      <div className="max-w-[640px] mx-auto mt-12 rounded-xl overflow-hidden shadow-[0_20px_60px_rgba(30,45,36,0.12)] animate-fade-up" style={{
      animationDelay: '0.5s'
    }} data-id="element-153">
        <img src="https://cdn.magicpatterns.com/uploads/n5WTanVshKC2cQ7FQS2yWm/unnamed.jpg" alt="Mamá leyendo con su hijo" className="w-full block" data-id="element-154" />
      </div>
    </section>;
}